import React from "react";
import { useCity } from "modules/api";

export const CityName: React.FC<{ id: string }> = ({ id }) => {
  const { data } = useCity(id, { suspense: true });
  return <>{data?.name || null}</>;
};
